import { IBieuDoRequest } from "../../../model/request/bieu-do/IBieuDoRequest";
import { IBieuDoResponse } from "../../../model/respone/bieu-do/IBieuDoResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IBieuDoBaseActionTypes<T> {
  type: number;
  data: T;
}
export const eBieuDoActionsObj = {
  LOAD_START: {} as IBieuDoRequest,
  LOAD_SUCCESS: {} as IBieuDoResponse,
  LOAD_ERRR: "",

  RELOAD_ALL: undefined,
};
export const eBieuDoActionTypeIds = generateActionTypeIds(
  eBieuDoActionsObj,
  "BIEU_DO"
);
export type IBieuDoActionTypes = IGenericActionType<
  typeof eBieuDoActionsObj,
  "BIEU_DO"
>;
